import {InfiniteData} from 'react-query';
import {PaginatedResponse} from '~types/api';

export const getListFromPages = <T>(data: InfiniteData<PaginatedResponse<T>> | undefined): T[] =>
  data?.pages
    ?.flat()
    ?.map(item => item?.data || item?.items)
    ?.flat()
    ?.filter(Boolean) || [];
